import isNil from "lodash/isNil";

import { EditAppointmentContent } from "@/constants/EditEvents";
import type { EditAppointmentScope } from "@/constants/EditEvents";
import { useAppUserSelector } from "@/store/reducers/appUser";
import AppointmentOverviewHeader from "@/ui/components/schedule/booking/AppointmentOverviewHeader";
import type { AvatarCardProps } from "@/ui/core";
import { Text } from "@/ui/core";
import AvatarCard from "@/ui/core/AvatarCard";
import { Box, FlatList, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

interface RescheduleOverviewCardProps extends ViewWithTestID {
  attendees: AvatarCardProps[];
  eventTitle: string;
  recurrence?: EventRecurrence;
  scope: EditAppointmentScope;
  selectedTimeSlot?: TimeSlot;
}
const RescheduleOverviewCard = ({
  attendees,
  eventTitle,
  recurrence,
  scope,
  selectedTimeSlot,
  testID,
}: RescheduleOverviewCardProps) => {
  const { confirmationDescription } = EditAppointmentContent[scope];

  const { externalId: appUserId } = useAppUserSelector();

  if (isNil(selectedTimeSlot)) {
    return null;
  }

  return (
    <VStack gap={12} paddingBottom={24}>
      <Box paddingBottom={12}>
        <Text color={ColorToken.NeutralPrimary} testID={testID}>
          {confirmationDescription}
        </Text>
      </Box>
      <AppointmentOverviewHeader
        appointmentTitle={eventTitle}
        attendeeCount={attendees.length}
        recurrence={recurrence}
        testID={testID}
        timeRange={{
          endTime: selectedTimeSlot.end,
          startTime: selectedTimeSlot.start,
        }}
      />
      <FlatList
        data={attendees}
        renderItem={({ item }) => {
          const isAppUser = item.userId === appUserId;

          return (
            <AvatarCard
              isAppUser={isAppUser}
              pronouns={item.pronouns}
              userId={item.userId}
              userName={item.userName}
              userType={item.userType}
            />
          );
        }}
        shouldRemoveContentVerticalPadding
        shouldRemoveStyleHorizontalPadding
        testID={testID}
      />
    </VStack>
  );
};

export type { RescheduleOverviewCardProps };
export default RescheduleOverviewCard;
